export default __webpack_public_path__ + "static/media/News.bbdb032c.svg";